import CountUp from './CountUp.vue';
import withInstall from '@/shared/withInstall';

export const XCountUp = withInstall(CountUp);
export default XCountUp;
